import React, { useState } from 'react';
import { Box } from '@mui/material';

import { MVPFiltersProps } from '../../advanta-mvp-charts/constants';
import { MVPDataTableInternal } from '../components/table';

import {
  TextField,
  InputAdornment,
  Switch,
  FormControlLabel,
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HistoryIcon from '@mui/icons-material/History';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import CommonAppBarAdmin from '../../../components/commonAppBarAdmin';
import * as yup from 'yup';

export const organizerSchema = yup.object({
  name: yup.string().required('Name is required'),
  code: yup.string().required('Code is required'),
  //organizer: yup.string().required('Organizer is required'),
  organizer: yup.string(),
  status: yup.string().required('Status is required'),
  mobile: yup.string().required('Mobile is required'),
  country: yup.string().required('Country is required'),
  fatherName: yup
    .string()
    .required('Father name is required'),
});

export const OrganizerManagement: React.FC<
  MVPFiltersProps
> = ({ onNavigate, onBack }) => {
  const [showWithoutCode, setShowWithoutCode] =
    useState(false);
  return (
    <div>
      {
        <CommonAppBarAdmin
          height={'auto'}
          title={'Organizer Management'}
          onBack={onBack}
          section={
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}>
                <TextField
                  placeholder="Search by name"
                  size="small"
                  variant="outlined"
                  sx={{
                    minWidth: 220,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#fafafa',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />

                <FormControlLabel
                  control={
                    <Switch
                      checked={showWithoutCode}
                      onChange={(e) =>
                        setShowWithoutCode(e.target.checked)
                      }
                      color="default"
                      size="small"
                    />
                  }
                  label="Show without Code"
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontSize: 14,
                      color: '#555',
                    },
                  }}
                />
              </Box>

              {/* Right section */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                }}>
                <Button
                  startIcon={<HistoryIcon />}
                  onClick={() => {
                    onNavigate?.('importHistory');
                  }}
                  sx={{
                    textTransform: 'none',
                    color: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                  }}>
                  View History
                </Button>

                <Button
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  sx={{
                    textTransform: 'none',
                    borderColor: 'rgba(0,105,112,1)',
                    color: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                    '&:hover': {
                      borderColor: 'rgba(0,105,112,0.8)',
                      backgroundColor:
                        'rgba(0,105,112,0.05)',
                    },
                  }}>
                  Import
                </Button>

                <Button
                  startIcon={<UploadIcon />}
                  variant="contained"
                  sx={{
                    textTransform: 'none',
                    backgroundColor: 'rgba(0,105,112,1)',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor:
                        'rgba(0,105,112,0.9)',
                    },
                  }}>
                  Export
                </Button>
              </Box>
            </>
          }
        />
      }
      <div style={{ marginTop: 80 }}></div>
      <MVPDataTableInternal type={'organizer'} />
    </div>
  );
};
